module.exports = __webpack_public_path__ + "img/second_.19c37a8e.jpg";